import { render, staticRenderFns } from "./selectButton.vue?vue&type=template&id=674a016b&scoped=true&"
import script from "./selectButton.vue?vue&type=script&lang=js&"
export * from "./selectButton.vue?vue&type=script&lang=js&"
import style0 from "./selectButton.vue?vue&type=style&index=0&id=674a016b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a016b",
  null
  
)

export default component.exports